export const NewCustomerAcquisitionGoal = {
  parent: 'Account',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'New Customer Acquisition Goal',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    ParentId: {
      'bulk-upload-header': 'Parent ID',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
    AudienceIds: {
      'bulk-upload-header': 'Target',
    },
    AdditionalConversionValue: {
      'bulk-upload-header': 'Additional Conversion Value',
    },
  },
};
